export const CARD_INPUT_ATTEMPT = {
  1: 1,
  2: 2,
  3: 3,
  4: 4,
  5: 5,
} as const;

export type TCardInputAttempt = typeof CARD_INPUT_ATTEMPT[keyof typeof CARD_INPUT_ATTEMPT];